"use strict";

var _toConsumableArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/toConsumableArray.js");
var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js");
var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass.js");
var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck.js");
var _inherits = require("/opt/build/repo/node_modules/@babel/runtime/helpers/inherits.js");
var _possibleConstructorReturn = require("/opt/build/repo/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
var _getPrototypeOf = require("/opt/build/repo/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
var _wrapNativeSuper = require("/opt/build/repo/node_modules/@babel/runtime/helpers/wrapNativeSuper.js");
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HereWallet = void 0;
var near_api_js_1 = require("near-api-js");
var providers_1 = require("near-api-js/lib/providers");
var key_pair_1 = require("near-api-js/lib/utils/key_pair");
var js_sha256_1 = require("js-sha256");
var bn_js_1 = __importDefault(require("bn.js"));
var HereKeyStore_1 = require("./HereKeyStore");
var provider_1 = require("./provider");
var utils_1 = require("./utils");
var here_provider_1 = require("./here-provider");
var actions_1 = require("./actions");
var WidgetStrategy_1 = require("./WidgetStrategy");
var AccessDenied = /*#__PURE__*/function (_Error) {
  _inherits(AccessDenied, _Error);
  var _super = _createSuper(AccessDenied);
  function AccessDenied() {
    _classCallCheck(this, AccessDenied);
    return _super.apply(this, arguments);
  }
  return _createClass(AccessDenied);
}( /*#__PURE__*/_wrapNativeSuper(Error));
var HereWallet = /*#__PURE__*/function () {
  function HereWallet() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      nodeUrl = _ref.nodeUrl,
      _ref$networkId = _ref.networkId,
      networkId = _ref$networkId === void 0 ? "mainnet" : _ref$networkId,
      _ref$authStorage = _ref.authStorage,
      authStorage = _ref$authStorage === void 0 ? new HereKeyStore_1.HereKeyStore() : _ref$authStorage,
      _ref$defaultStrategy = _ref.defaultStrategy,
      defaultStrategy = _ref$defaultStrategy === void 0 ? function () {
        return new WidgetStrategy_1.WidgetStrategy();
      } : _ref$defaultStrategy,
      _ref$defaultProvider = _ref.defaultProvider,
      defaultProvider = _ref$defaultProvider === void 0 ? here_provider_1.proxyProvider : _ref$defaultProvider;
    _classCallCheck(this, HereWallet);
    this.authStorage = authStorage;
    this.defaultProvider = defaultProvider;
    this.defaultStrategy = defaultStrategy;
    var signer = new near_api_js_1.InMemorySigner(this.authStorage);
    var rpc = new providers_1.JsonRpcProvider({
      url: nodeUrl !== null && nodeUrl !== void 0 ? nodeUrl : "https://rpc.".concat(networkId, ".near.org")
    });
    this.connection = near_api_js_1.Connection.fromConfig({
      jsvmAccountId: "jsvm.".concat(networkId),
      provider: rpc,
      networkId: networkId,
      signer: signer
    });
  }
  _createClass(HereWallet, [{
    key: "rpc",
    get: function get() {
      return this.connection.provider;
    }
  }, {
    key: "signer",
    get: function get() {
      return this.connection.signer;
    }
  }, {
    key: "networkId",
    get: function get() {
      return this.connection.networkId;
    }
  }, {
    key: "account",
    value: function account(id) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var accountId;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(id !== null && id !== void 0)) {
                _context.next = 4;
                break;
              }
              _context.t0 = id;
              _context.next = 7;
              break;
            case 4:
              _context.next = 6;
              return this.authStorage.getActiveAccount(this.networkId);
            case 6:
              _context.t0 = _context.sent;
            case 7:
              accountId = _context.t0;
              if (!(accountId == null)) {
                _context.next = 10;
                break;
              }
              throw new Error("Wallet not signed in");
            case 10:
              return _context.abrupt("return", new near_api_js_1.Account(this.connection, accountId));
            case 11:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "isSignedIn",
    value: function isSignedIn() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var id;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.authStorage.getActiveAccount(this.networkId);
            case 2:
              id = _context2.sent;
              return _context2.abrupt("return", id != null);
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
    }
  }, {
    key: "signOut",
    value: function signOut() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var accountId, key, publicKey;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return this.authStorage.getActiveAccount(this.networkId);
            case 2:
              accountId = _context3.sent;
              if (!(accountId == null)) {
                _context3.next = 5;
                break;
              }
              throw new Error("Wallet not signed in");
            case 5:
              _context3.next = 7;
              return this.authStorage.getKey(this.networkId, accountId);
            case 7:
              key = _context3.sent;
              if (!(key != null)) {
                _context3.next = 12;
                break;
              }
              publicKey = key.getPublicKey().toString();
              _context3.next = 12;
              return this.silentSignAndSendTransaction({
                receiverId: accountId,
                actions: [{
                  type: "DeleteKey",
                  params: {
                    publicKey: publicKey
                  }
                }]
              }).catch(function () {});
            case 12:
              _context3.next = 14;
              return this.authStorage.removeKey(this.networkId, accountId);
            case 14:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
    }
  }, {
    key: "getHereBalance",
    value: function getHereBalance(id) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var account, contractId, hereCoins;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return this.account(id);
            case 2:
              account = _context4.sent;
              contractId = this.networkId === "mainnet" ? "here.storage.near" : "here.storage.testnet";
              _context4.next = 6;
              return account.viewFunction({
                args: {
                  account_id: account.accountId
                },
                methodName: "ft_balance_of",
                contractId: contractId
              }).catch(function () {
                return "0";
              });
            case 6:
              hereCoins = _context4.sent;
              return _context4.abrupt("return", new bn_js_1.default(hereCoins));
            case 8:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
    }
  }, {
    key: "getAvailableBalance",
    value: function getAvailableBalance(id) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var account, result, hereBalance;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return this.account(id);
            case 2:
              account = _context5.sent;
              _context5.next = 5;
              return account.getAccountBalance();
            case 5:
              result = _context5.sent;
              _context5.next = 8;
              return this.getHereBalance();
            case 8:
              hereBalance = _context5.sent;
              return _context5.abrupt("return", new bn_js_1.default(result.available).add(new bn_js_1.default(hereBalance)));
            case 10:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
    }
  }, {
    key: "getAccounts",
    value: function getAccounts() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return this.authStorage.getAccounts(this.networkId);
            case 2:
              return _context6.abrupt("return", _context6.sent);
            case 3:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
    }
  }, {
    key: "getAccountId",
    value: function getAccountId() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        var accountId;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return this.authStorage.getActiveAccount(this.networkId);
            case 2:
              accountId = _context7.sent;
              if (!(accountId == null)) {
                _context7.next = 5;
                break;
              }
              throw new Error("Wallet not signed in");
            case 5:
              return _context7.abrupt("return", accountId);
            case 6:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
    }
  }, {
    key: "switchAccount",
    value: function switchAccount(id) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        var key;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return this.authStorage.getKey(this.networkId, id);
            case 2:
              key = _context8.sent;
              if (!(key == null)) {
                _context8.next = 5;
                break;
              }
              throw new Error("Account ".concat(id, " not signed in"));
            case 5:
              _context8.next = 7;
              return this.authStorage.setActiveAccount(this.networkId, id);
            case 7:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
    }
  }, {
    key: "signIn",
    value: function signIn() {
      var _a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _b, _c, _d, _e, _f;
      var contractId = _a.contractId,
        allowance = _a.allowance,
        _a$methodNames = _a.methodNames,
        methodNames = _a$methodNames === void 0 ? [] : _a$methodNames,
        delegate = __rest(_a, ["contractId", "allowance", "methodNames"]);
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
        var _yield$this$signMessa, accountId, accessKey, permission, data;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              if (!(contractId == null)) {
                _context9.next = 10;
                break;
              }
              _context9.next = 3;
              return this.signMessage(Object.assign({
                receiver: window.location.host,
                message: "Sign this message to sign in"
              }, delegate));
            case 3:
              _yield$this$signMessa = _context9.sent;
              accountId = _yield$this$signMessa.accountId;
              _context9.next = 7;
              return this.authStorage.setKey(this.networkId, accountId, key_pair_1.KeyPairEd25519.fromRandom());
            case 7:
              _context9.next = 9;
              return this.authStorage.setActiveAccount(this.networkId, accountId);
            case 9:
              return _context9.abrupt("return", accountId);
            case 10:
              delegate.strategy = (_b = delegate.strategy) !== null && _b !== void 0 ? _b : this.defaultStrategy();
              delegate.provider = (_c = delegate.provider) !== null && _c !== void 0 ? _c : this.defaultProvider;
              (_d = delegate.onInitialized) === null || _d === void 0 ? void 0 : _d.call(delegate);
              (_f = (_e = delegate.strategy) === null || _e === void 0 ? void 0 : _e.onInitialized) === null || _f === void 0 ? void 0 : _f.call(_e);
              _context9.prev = 14;
              accessKey = near_api_js_1.KeyPair.fromRandom("ed25519");
              permission = {
                receiverId: contractId,
                methodNames: methodNames,
                allowance: allowance
              };
              _context9.next = 19;
              return delegate.provider(Object.assign(Object.assign({}, delegate), {
                request: {
                  type: "call",
                  network: this.networkId,
                  transactions: [{
                    actions: [{
                      type: "AddKey",
                      params: {
                        publicKey: accessKey.getPublicKey().toString(),
                        accessKey: {
                          permission: permission
                        }
                      }
                    }]
                  }]
                }
              }));
            case 19:
              data = _context9.sent;
              if (!(data.account_id == null)) {
                _context9.next = 22;
                break;
              }
              throw Error("Transaction is failed");
            case 22:
              _context9.next = 24;
              return this.authStorage.setKey(this.networkId, data.account_id, accessKey);
            case 24:
              _context9.next = 26;
              return this.authStorage.setActiveAccount(this.networkId, data.account_id);
            case 26:
              return _context9.abrupt("return", data.account_id);
            case 29:
              _context9.prev = 29;
              _context9.t0 = _context9["catch"](14);
              (0, utils_1.internalThrow)(_context9.t0, delegate);
              throw _context9.t0;
            case 33:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this, [[14, 29]]);
      }));
    }
  }, {
    key: "silentSignAndSendTransaction",
    value: function silentSignAndSendTransaction(_ref2) {
      var actions = _ref2.actions,
        receiverId = _ref2.receiverId,
        signerId = _ref2.signerId;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
        var account, localKey, publicKey, accessKeys, call, isValid;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              _context10.next = 2;
              return this.account(signerId);
            case 2:
              account = _context10.sent;
              _context10.next = 5;
              return this.authStorage.getKey(this.networkId, account.accountId);
            case 5:
              localKey = _context10.sent;
              if (!(localKey == null)) {
                _context10.next = 8;
                break;
              }
              throw new AccessDenied();
            case 8:
              publicKey = localKey.getPublicKey();
              _context10.next = 11;
              return account.getAccessKeys();
            case 11:
              accessKeys = _context10.sent;
              call = {
                receiverId: receiverId,
                actions: actions
              };
              isValid = accessKeys.some(function (v) {
                if (v.public_key !== publicKey.toString()) return false;
                return (0, utils_1.isValidAccessKey)(account.accountId, v, call);
              });
              if (!(isValid === false)) {
                _context10.next = 16;
                break;
              }
              throw new AccessDenied();
            case 16:
              _context10.next = 18;
              return account.signAndSendTransaction({
                actions: actions.map(function (a) {
                  return (0, actions_1.createAction)(a);
                }),
                receiverId: receiverId !== null && receiverId !== void 0 ? receiverId : account.accountId
              });
            case 18:
              return _context10.abrupt("return", _context10.sent);
            case 19:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this);
      }));
    }
  }, {
    key: "signAndSendTransaction",
    value: function signAndSendTransaction(opts) {
      var _a, _b, _c, _d, _e, _f, _g, _h;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
        var signerId, receiverId, actions, args, delegate, result, success, data;
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              signerId = opts.signerId, receiverId = opts.receiverId, actions = opts.actions, args = __rest(opts, ["signerId", "receiverId", "actions"]);
              delegate = args;
              delegate.strategy = (_a = delegate.strategy) !== null && _a !== void 0 ? _a : this.defaultStrategy();
              delegate.provider = (_b = delegate.provider) !== null && _b !== void 0 ? _b : this.defaultProvider;
              (_c = delegate.onInitialized) === null || _c === void 0 ? void 0 : _c.call(delegate);
              (_e = (_d = delegate.strategy) === null || _d === void 0 ? void 0 : _d.onInitialized) === null || _e === void 0 ? void 0 : _e.call(_d);
              _context11.prev = 6;
              _context11.next = 9;
              return this.silentSignAndSendTransaction({
                receiverId: receiverId,
                actions: actions,
                signerId: signerId
              });
            case 9:
              result = _context11.sent;
              success = {
                status: provider_1.HereProviderStatus.SUCCESS,
                payload: result === null || result === void 0 ? void 0 : result.transaction_outcome.id
              };
              (_f = delegate.onSuccess) === null || _f === void 0 ? void 0 : _f.call(delegate, success);
              (_h = (_g = delegate.strategy) === null || _g === void 0 ? void 0 : _g.onSuccess) === null || _h === void 0 ? void 0 : _h.call(_g, success);
              return _context11.abrupt("return", result);
            case 16:
              _context11.prev = 16;
              _context11.t0 = _context11["catch"](6);
              _context11.prev = 18;
              if (!(!(_context11.t0 instanceof AccessDenied) && (_context11.t0 === null || _context11.t0 === void 0 ? void 0 : _context11.t0.type) !== "NotEnoughAllowance")) {
                _context11.next = 22;
                break;
              }
              (0, utils_1.internalThrow)(_context11.t0, delegate);
              throw _context11.t0;
            case 22:
              _context11.next = 24;
              return delegate.provider(Object.assign(Object.assign({}, delegate), {
                request: {
                  type: "call",
                  transactions: [{
                    actions: (0, utils_1.serializeActions)(actions),
                    receiverId: receiverId,
                    signerId: signerId
                  }],
                  network: this.networkId
                }
              }));
            case 24:
              data = _context11.sent;
              if (!(data.payload == null || data.account_id == null)) {
                _context11.next = 27;
                break;
              }
              throw Error("Transaction not found, but maybe executed");
            case 27:
              _context11.next = 29;
              return this.rpc.txStatus(data.payload, data.account_id);
            case 29:
              return _context11.abrupt("return", _context11.sent);
            case 32:
              _context11.prev = 32;
              _context11.t1 = _context11["catch"](18);
              (0, utils_1.internalThrow)(_context11.t1, delegate);
              throw _context11.t1;
            case 36:
            case "end":
              return _context11.stop();
          }
        }, _callee11, this, [[6, 16], [18, 32]]);
      }));
    }
    /** Implement NEP0413 */
  }, {
    key: "signMessage",
    value: function signMessage(_a) {
      var _b, _c, _d, _e, _f;
      var message = _a.message,
        receiver = _a.receiver,
        nonce = _a.nonce,
        delegate = __rest(_a, ["message", "receiver", "nonce"]);
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee12() {
        var nonceArray, data, _JSON$parse, publicKey, signature, accountId, sign, json, msg, isVerify, account, keys, pb, isValid;
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              delegate.strategy = (_b = delegate.strategy) !== null && _b !== void 0 ? _b : this.defaultStrategy();
              delegate.provider = (_c = delegate.provider) !== null && _c !== void 0 ? _c : this.defaultProvider;
              (_d = delegate.onInitialized) === null || _d === void 0 ? void 0 : _d.call(delegate);
              (_f = (_e = delegate.strategy) === null || _e === void 0 ? void 0 : _e.onInitialized) === null || _f === void 0 ? void 0 : _f.call(_e);
              if (nonce == null) {
                nonceArray = new Uint8Array(32);
                nonce = _toConsumableArray(crypto.getRandomValues(nonceArray));
              }
              _context12.next = 7;
              return delegate.provider(Object.assign(Object.assign({}, delegate), {
                request: {
                  type: "sign",
                  message: message,
                  receiver: receiver,
                  nonce: nonce,
                  network: this.networkId
                }
              }));
            case 7:
              data = _context12.sent;
              if (!(data.payload == null)) {
                _context12.next = 10;
                break;
              }
              throw Error("Signature not found");
            case 10:
              _context12.prev = 10;
              _JSON$parse = JSON.parse(data.payload), publicKey = _JSON$parse.publicKey, signature = _JSON$parse.signature, accountId = _JSON$parse.accountId;
              sign = new Uint8Array(Buffer.from(signature, "base64"));
              json = JSON.stringify({
                message: message,
                receiver: receiver,
                nonce: nonce
              });
              msg = new Uint8Array(js_sha256_1.sha256.digest("NEP0413:" + json));
              isVerify = key_pair_1.PublicKey.from(publicKey).verify(msg, sign);
              if (!(isVerify === false)) {
                _context12.next = 18;
                break;
              }
              throw Error();
            case 18:
              _context12.next = 20;
              return this.account(accountId);
            case 20:
              account = _context12.sent;
              _context12.next = 23;
              return account.getAccessKeys();
            case 23:
              keys = _context12.sent;
              pb = publicKey.toString();
              isValid = keys.some(function (k) {
                if (k.public_key !== pb) return false;
                if (k.access_key.permission !== "FullAccess") return false;
                return true;
              });
              if (!(isValid === false)) {
                _context12.next = 28;
                break;
              }
              throw Error();
            case 28:
              return _context12.abrupt("return", {
                signature: new Uint8Array(Buffer.from(signature, "base64")),
                publicKey: key_pair_1.PublicKey.from(publicKey),
                message: "NEP0413:" + json,
                receiver: receiver,
                accountId: accountId,
                nonce: nonce
              });
            case 31:
              _context12.prev = 31;
              _context12.t0 = _context12["catch"](10);
              throw Error("Signature not correct");
            case 34:
            case "end":
              return _context12.stop();
          }
        }, _callee12, this, [[10, 31]]);
      }));
    }
  }, {
    key: "signAndSendTransactions",
    value: function signAndSendTransactions(_a) {
      var _b, _c, _d, _e, _f, _g, _h, _j;
      var transactions = _a.transactions,
        delegate = __rest(_a, ["transactions"]);
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee13() {
        var _this = this;
        var results, _iterator, _step, call, r, payload, success, uncompleted, data, promises;
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              delegate.strategy = (_b = delegate.strategy) !== null && _b !== void 0 ? _b : this.defaultStrategy();
              delegate.provider = (_c = delegate.provider) !== null && _c !== void 0 ? _c : this.defaultProvider;
              (_d = delegate.onInitialized) === null || _d === void 0 ? void 0 : _d.call(delegate);
              (_f = (_e = delegate.strategy) === null || _e === void 0 ? void 0 : _e.onInitialized) === null || _f === void 0 ? void 0 : _f.call(_e);
              results = [];
              _context13.prev = 5;
              _iterator = _createForOfIteratorHelper(transactions);
              _context13.prev = 7;
              _iterator.s();
            case 9:
              if ((_step = _iterator.n()).done) {
                _context13.next = 17;
                break;
              }
              call = _step.value;
              _context13.next = 13;
              return this.silentSignAndSendTransaction(call);
            case 13:
              r = _context13.sent;
              results.push(r);
            case 15:
              _context13.next = 9;
              break;
            case 17:
              _context13.next = 22;
              break;
            case 19:
              _context13.prev = 19;
              _context13.t0 = _context13["catch"](7);
              _iterator.e(_context13.t0);
            case 22:
              _context13.prev = 22;
              _iterator.f();
              return _context13.finish(22);
            case 25:
              payload = results.map(function (result) {
                return result.transaction_outcome.id;
              }).join(",");
              success = {
                status: provider_1.HereProviderStatus.SUCCESS,
                payload: payload
              };
              (_g = delegate.onSuccess) === null || _g === void 0 ? void 0 : _g.call(delegate, success);
              (_j = (_h = delegate.strategy) === null || _h === void 0 ? void 0 : _h.onSuccess) === null || _j === void 0 ? void 0 : _j.call(_h, success);
              return _context13.abrupt("return", results);
            case 32:
              _context13.prev = 32;
              _context13.t1 = _context13["catch"](5);
              _context13.prev = 34;
              if (!(!(_context13.t1 instanceof AccessDenied) && (_context13.t1 === null || _context13.t1 === void 0 ? void 0 : _context13.t1.type) !== "NotEnoughAllowance")) {
                _context13.next = 38;
                break;
              }
              (0, utils_1.internalThrow)(_context13.t1, delegate);
              throw _context13.t1;
            case 38:
              uncompleted = transactions.slice(results.length);
              _context13.next = 41;
              return delegate.provider(Object.assign(Object.assign({}, delegate), {
                request: {
                  type: "call",
                  transactions: uncompleted.map(function (trx) {
                    return Object.assign(Object.assign({}, trx), {
                      actions: (0, utils_1.serializeActions)(trx.actions)
                    });
                  }),
                  network: this.networkId
                }
              }));
            case 41:
              data = _context13.sent;
              if (!(data.payload == null || data.account_id == null)) {
                _context13.next = 44;
                break;
              }
              throw Error("Transaction not found, but maybe executed");
            case 44:
              promises = data.payload.split(",").map(function (id) {
                return _this.rpc.txStatus(id, data.account_id);
              });
              _context13.next = 47;
              return Promise.all(promises);
            case 47:
              return _context13.abrupt("return", _context13.sent);
            case 50:
              _context13.prev = 50;
              _context13.t2 = _context13["catch"](34);
              (0, utils_1.internalThrow)(_context13.t2, delegate);
              throw _context13.t2;
            case 54:
            case "end":
              return _context13.stop();
          }
        }, _callee13, this, [[5, 32], [7, 19, 22, 25], [34, 50]]);
      }));
    }
  }]);
  return HereWallet;
}();
exports.HereWallet = HereWallet;